'use strict'

import template from './switch-customer.template.pug'

class SwitchCustomerController {
  constructor($mdDialog, $state) {
    'ngInject'
    Object.assign(this, { $mdDialog, $state })
  }

  cancel() {
    this.$mdDialog.cancel()
  }

  goTo(customerId) {
    this.$state.go('customers.customer.tasksites', { customerId }).then(() => this.$mdDialog.hide())
  }
}

export const switchCustomerComponent = {
  controller: SwitchCustomerController,
  controllerAs: '$ctrl',
  clickOutsideToClose: true,
  escapeToClose: true,
  template: template(),
  fullscreen: true,
  bindToController: true,
}

export const switchCustomerConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('switchCustomerDialog', {
    options: () => {
      return switchCustomerComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/customers/components/switch-customer/switch-customer.component.js